import { render, staticRenderFns } from "./new-user-detail.vue?vue&type=template&id=4228ecf6&scoped=true"
import script from "./new-user-detail.vue?vue&type=script&lang=js"
export * from "./new-user-detail.vue?vue&type=script&lang=js"
import style0 from "./new-user-detail.vue?vue&type=style&index=0&id=4228ecf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228ecf6",
  null
  
)

export default component.exports